export const REGISTER = "REGISTER"
export const FAIL = "FAIL"
export const LOGIN ="LOGIN"
export const LOGOUT ="LOGOUT"
export const CURRENT ="CURRENT"
export const GETALLUSERS ="GETALLUSERS"
export const GETONEUSER ="GETONEUSER"
